import { FeV2ErrorCodes } from "@/apps/credit-line/models/IFeV2ErrorCode";

export const getErrorMessage = (
  errorCode: number,
  t: (key: string, values?: Record<string, unknown>) => string,
  deviceTag?: string,
  data?: string
): string => {
  if (FeV2ErrorCodes.find((code) => code === errorCode)) {
    return (
      t(`CL_ERROR_CODES.${errorCode}`, { deviceTag, data }) +
      ` (Error ${errorCode}).`
    );
  } else {
    return t("CL_GENERIC_ERROR", { errorCode });
  }
};
